import { render, staticRenderFns } from "./potionAdd.vue?vue&type=template&id=2cf5f7ca&scoped=true"
import script from "./potionAdd.vue?vue&type=script&lang=ts"
export * from "./potionAdd.vue?vue&type=script&lang=ts"
import style0 from "./potionAdd.vue?vue&type=style&index=0&id=2cf5f7ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf5f7ca",
  null
  
)

export default component.exports